package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class TooltipCallbacks(
    val title: ((Array<dynamic>) -> String)? = null,
    val label: ((dynamic) -> String)? = null,
    val beforeBody: ((Array<dynamic>) -> String)? = null,
    val afterBody: ((Array<dynamic>) -> String)? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (title != null) this.title = title
        if (label != null) this.label = label
        if (beforeBody != null) this.beforeBody = beforeBody
        if (afterBody != null) this.afterBody = afterBody
    }
}
